import React from "react";
import { Link } from "react-router-dom";
import websiteLogo from "../assets/websitelogo.png";

const getStoredUser = () => {
  try {
    const rawUser = localStorage.getItem('user');
    if (!rawUser) return null;
    const parsed = JSON.parse(rawUser);
    if (!parsed || typeof parsed !== 'object') return null;
    if (parsed.user_type === 'SUPERADMIN') return null;
    return parsed;
  } catch (error) {
    return null;
  }
};

const isAuthenticatedUser = () => {
  const user = getStoredUser();
  return Boolean(user && user.id);
};

const Footer = () => {
  const isLoggedIn = isAuthenticatedUser();
  return (
    <footer style={styles.footer}>
      <div style={styles.content}>

        {/* Left Branding & Address Column */}
        <div style={styles.brandSection}>
          <div style={styles.logoRow}>
            <img src={websiteLogo} alt="Arkalaksh logo" style={styles.logoImage} />
            <span style={styles.brandTitle}>Smart Interview</span>
          </div>
          <p style={styles.brandDesc}>
            Enterprise-grade multi-tenant AI assessment platform. Streamline tech hiring with automated, proctored code screenings and synchronized live workspaces.
          </p>
          <div style={styles.napBlock}>
            <p style={styles.napText}>
              <span>📍</span> <strong>HQ:</strong> Ajinkya Park, Rachna Eternia, Pan Card Club Rd, Baner, Pune, Maharashtra 411069
            </p>
            <p style={styles.napText}>
              <span>📞</span> <strong>Hotline:</strong>
              {/* +91 (80) 4967-1000 | */}
              ✉️ admin@arkalaksh.com
            </p>
          </div>
        </div>

        {/* Right Links Column Categories */}
        <div style={styles.linksWrapper}>
          <div style={styles.linksCol}>
            <h4 style={styles.colTitle}>Platform</h4>
            <Link to="/features" style={styles.link}>Features</Link>
            <Link to="/how" style={styles.link}>How It Works</Link>
          </div>
          {!isLoggedIn && (
            <div style={styles.linksCol}>
              <h4 style={styles.colTitle}>Corporate Info</h4>
              <Link to="/contact" style={styles.link}>Contact Support</Link>
              <Link to="/privacy" style={styles.link}>Privacy Policy</Link>
            </div>
          )}
        </div>
      </div>

      <div style={styles.divider}></div>

      {/* Footer Bottom copyright notes */}
      <div style={styles.subFooterContent}>
        <p style={styles.copyrightText}>
          © {new Date().getFullYear()} Smart Interview. All rights reserved. Securely isolated database architecture.
        </p>
        <span
          style={styles.backToTop}
          onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
          role="button"
          tabIndex={0}
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              window.scrollTo({ top: 0, behavior: 'smooth' });
            }
          }}
        >
          Back to Top ↑
        </span>
      </div>
    </footer>
  );
};

const styles = {
  footer: {
    width: "100%",
    padding: "60px 40px 30px 40px",
    background: "var(--bg-footer)",
    borderTop: "1px solid var(--border-footer)",
    marginTop: "120px",
    fontFamily: "'Inter', sans-serif",
    boxSizing: "border-box",
    transition: "background-color 0.3s ease, border-color 0.3s ease",
  },

  content: {
    maxWidth: "1320px",
    width: "100%",
    margin: "0 auto",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
    flexWrap: "wrap",
    gap: "40px",
  },

  brandSection: {
    flex: "1 1 450px",
    display: "flex",
    flexDirection: "column",
    gap: "16px",
  },

  logoRow: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
  },

  logoIcon: {
    fontSize: "24px",
  },

  logoImage: {
    width: "52px",
    height: "52px",
    objectFit: "contain",
    display: "block",
  },

  brandTitle: {
    fontSize: "22px",
    fontWeight: "800",
    letterSpacing: "0.5px",
    color: "var(--text-primary)",
    fontFamily: "'Outfit', sans-serif",
  },

  brandDesc: {
    fontSize: "14px",
    color: "var(--text-secondary)",
    lineHeight: "1.6",
    margin: 0,
    maxWidth: "400px",
  },

  napBlock: {
    display: "flex",
    flexDirection: "column",
    gap: "10px",
    marginTop: "8px",
  },

  napText: {
    fontSize: "13px",
    color: "var(--text-tertiary)",
    margin: 0,
    lineHeight: "1.5",
    display: "flex",
    alignItems: "center",
    gap: "6px",
  },

  linksWrapper: {
    display: "flex",
    gap: "60px",
    flexWrap: "wrap",
    flex: "1 1 300px",
    justifyContent: "flex-end",
  },

  linksCol: {
    display: "flex",
    flexDirection: "column",
    gap: "12px",
    minWidth: "140px",
  },

  colTitle: {
    fontSize: "13px",
    fontWeight: "700",
    textTransform: "uppercase",
    letterSpacing: "1px",
    color: "#4f46e5",
    margin: "0 0 4px 0",
  },

  link: {
    fontSize: "14px",
    color: "var(--text-secondary)",
    textDecoration: "none",
    fontWeight: "500",
    transition: "color 0.2s ease",
  },

  divider: {
    maxWidth: "1320px",
    height: "1px",
    background: "var(--border-color)",
    margin: "40px auto 24px auto",
    width: "100%",
  },

  subFooterContent: {
    maxWidth: "1320px",
    margin: "0 auto",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    flexWrap: "wrap",
    gap: "16px",
    width: "100%",
  },

  copyrightText: {
    fontSize: "13px",
    color: "var(--text-muted)",
    margin: 0,
  },

  backToTop: {
    fontSize: "13px",
    color: "#4f46e5",
    cursor: "pointer",
    fontWeight: "600",
    transition: "color 0.2s ease",
  }
};

export default Footer;